/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Patient/view.blocks to change it.
import Patients from './Patients/index'
import React from 'react'
import Term from './Term/index'



/** @type {import('Simple/types.js').View} */
export default function Patient({
  children,
  viewPath = "/App/Account/NewPatient/Content/Form/ReferralsSection/New/Confirm/Content/Referral/Value/Search/Patient"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Patient.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Term
  viewPath={`${viewPath}/Term`}
/>
<Patients
  viewPath={`${viewPath}/Patients`}
/>
</div>
{children}
</React.Fragment>)
}